/* Unruly Pack theme JS - interactive engine */
(function () {
  'use strict';

  var cfg = window.TT || {};
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(pointer: fine)').matches;
  var isMobile = window.matchMedia('(max-width: 767px)').matches || !finePointer;
  var hasGsap = typeof window.gsap !== 'undefined';
  var hasST = hasGsap && typeof window.ScrollTrigger !== 'undefined';

  document.documentElement.classList.add('tt-motion');
  document.documentElement.classList.remove('no-js');

  /* Parallax master switch: setting / reduced-motion / mobile */
  var parallaxMode = cfg.parallax || 'bold';
  var parallaxOn = parallaxMode !== 'off' && !reducedMotion && !isMobile && hasST;
  var INT = parallaxMode === 'bold' ? 1 : 0.45; /* intensity multiplier */
  if (hasST) gsap.registerPlugin(ScrollTrigger);

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    if (cfg.currency) {
      return new Intl.NumberFormat(cfg.locale || 'en', {style: 'currency', currency: cfg.currency}).format(cents / 100);
    }
    var fmt = cfg.moneyFormat || '${{amount}}';
    return fmt.replace('{{amount_with_comma_separator}}', (cents / 100).toFixed(2).replace('.', ',')).replace('{{amount}}', (cents / 100).toFixed(2));
  }

  /* ---------- Toast ---------- */
  var toastEl = document.getElementById('tt-cart-toast');
  var toastTimer = null;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-show'); }, 2600);
  }

  /* ---------- Reveal on scroll ---------- */
  var revealIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); revealIO.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.tt-reveal').forEach(function (el) { revealIO.observe(el); });

  /* ---------- Header: scroll state + mobile nav ---------- */
  var header = document.getElementById('tt-header');
  var navToggle = document.getElementById('tt-nav-toggle');
  var nav = document.getElementById('tt-nav');
  var navOverlay = document.getElementById('tt-nav-overlay');
  function onScrollHeader() {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 24);
  }
  window.addEventListener('scroll', onScrollHeader, { passive: true });
  onScrollHeader();
  function closeNav() {
    if (nav) nav.classList.remove('is-open');
    if (navOverlay) navOverlay.classList.remove('is-open');
    if (navToggle) navToggle.setAttribute('aria-expanded', 'false');
  }
  if (navToggle) {
    navToggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      navOverlay.classList.toggle('is-open', open);
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  if (navOverlay) navOverlay.addEventListener('click', closeNav);
  /* Mobile drawer: ensure taps on nav links navigate (close drawer, then go) */
  if (nav) {
    nav.addEventListener('click', function (e) {
      var link = e.target.closest('a.tt-nav-link');
      if (!link) return;
      var item = link.closest('.tt-has-dropdown');
      /* If it has a dropdown and dropdown isn't open yet, let the dropdown handler deal with it */
      if (item && item.querySelector('.tt-dropdown') && !item.classList.contains('is-open')) return;
      var href = link.getAttribute('href');
      if (href && href !== '#') {
        e.preventDefault();
        closeNav();
        window.location.href = href;
      }
    });
  }

  /* ---------- Desktop dropdowns: one open at a time, forgiving hover ---------- */
  (function dropdowns() {
    var items = document.querySelectorAll('.tt-has-dropdown');
    if (!items.length) return;
    var closeTimer = null;
    function closeAll(except) {
      items.forEach(function (it) { if (it !== except) it.classList.remove('is-open'); });
    }
    items.forEach(function (item) {
      var link = item.querySelector('.tt-nav-link');
      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        closeAll(item);
        item.classList.add('is-open');
      });
      item.addEventListener('mouseleave', function () {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () { item.classList.remove('is-open'); }, 180);
      });
      if (link) {
        link.addEventListener('click', function (e) {
          if (item.querySelector('.tt-dropdown')) {
            var wasOpen = item.classList.contains('is-open');
            closeAll();
            if (!wasOpen) { e.preventDefault(); item.classList.add('is-open'); }
          }
        });
      }
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.tt-has-dropdown')) closeAll();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
    /* keyboard: close when focus leaves the dropdown entirely */
    items.forEach(function (item) {
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) item.classList.remove('is-open');
      });
    });
  })();

  /* ============================================================
     PARALLAX ENGINE (signature brand effect)
     ============================================================ */

  /* 1. HERO: multi-layer scroll parallax + mouse parallax */
  if (parallaxOn) {
    document.querySelectorAll('[data-tt-hero]').forEach(function (hero) {
      var layers = hero.querySelectorAll('[data-depth]');
      layers.forEach(function (layer) {
        var depth = parseFloat(layer.getAttribute('data-depth')) || 0.2;
        /* Scroll: deeper layers travel further as hero scrolls away */
        gsap.to(layer, {
          y: function () { return depth * 420 * INT; },
          ease: 'none',
          scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: 0.6 }
        });
      });
      /* Mouse: layers drift with cursor, depth-scaled (quickTo = smooth, no tween pileup) */
      if (finePointer) {
        var xTos = [];
        layers.forEach(function (layer) {
          xTos.push({
            xTo: gsap.quickTo(layer, 'x', { duration: 0.7, ease: 'power2.out' }),
            depth: parseFloat(layer.getAttribute('data-depth')) || 0.2
          });
        });
        hero.addEventListener('mousemove', function (e) {
          var r = hero.getBoundingClientRect();
          var nx = (e.clientX - r.left) / r.width - 0.5;
          xTos.forEach(function (s) { s.xTo(nx * s.depth * 130 * INT); });
        });
        hero.addEventListener('mouseleave', function () {
          xTos.forEach(function (s) { s.xTo(0); });
        });
      }
    });
  }

  /* 2. SECTION BACKGROUNDS: banners glide slower than content */
  if (parallaxOn) {
    document.querySelectorAll('[data-tt-parallax-bg]').forEach(function (sec) {
      var bg = sec.querySelector('.tt-banner-bg');
      if (!bg) return;
      gsap.fromTo(bg, { yPercent: -9 * INT }, {
        yPercent: 9 * INT, ease: 'none',
        scrollTrigger: { trigger: sec, start: 'top bottom', end: 'bottom top', scrub: 0.8 }
      });
      /* content rises gently against the background */
      var content = sec.querySelector('.tt-banner-content');
      if (content) {
        gsap.fromTo(content, { y: 50 * INT }, {
          y: -50 * INT, ease: 'none',
          scrollTrigger: { trigger: sec, start: 'top bottom', end: 'bottom top', scrub: 0.8 }
        });
      }
    });
  }

  /* 3. PRODUCT CARDS: subtle rotate + translate as they enter */
  if (parallaxOn) {
    document.querySelectorAll('.tt-product-card').forEach(function (card, i) {
      var dir = i % 2 === 0 ? 1 : -1;
      gsap.fromTo(card,
        { y: 46 * INT, rotation: 1.6 * dir * INT, opacity: 0.4 },
        {
          y: 0, rotation: 0, opacity: 1, ease: 'none',
          scrollTrigger: { trigger: card, start: 'top 96%', end: 'top 58%', scrub: 0.7 }
        });
    });
  }

  /* 4. BREED GRID: staggered offsets per card */
  if (parallaxOn) {
    document.querySelectorAll('.tt-breed-flip').forEach(function (el, i) {
      var offset = (56 + (i % 4) * 26) * INT;
      gsap.fromTo(el, { y: offset, opacity: 0.35 }, {
        y: 0, opacity: 1, ease: 'none',
        scrollTrigger: { trigger: el, start: 'top 96%', end: 'top 55%', scrub: 0.7 }
      });
    });
  }

  /* 5. FOOTER: parallax lift reveal */
  if (parallaxOn) {
    var footer = document.querySelector('.tt-footer');
    if (footer) {
      gsap.fromTo(footer, { y: 90 * INT }, {
        y: 0, ease: 'none',
        scrollTrigger: { trigger: footer, start: 'top 102%', end: 'top 62%', scrub: 0.8 }
      });
    }
  }

  /* ---------- 3D tilt on hover (desktop) ---------- */
  if (finePointer && !reducedMotion) {
    document.querySelectorAll('.tt-tilt').forEach(function (card) {
      var inner = card.querySelector('.tt-tilt-inner');
      if (!inner) return;
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        inner.style.transform = 'rotateY(' + (px * 14) + 'deg) rotateX(' + (-py * 14) + 'deg) translateZ(8px)';
      });
      card.addEventListener('mouseleave', function () { inner.style.transform = ''; });
    });
  }

  /* Breed flip: tap toggles on touch */
  document.querySelectorAll('[data-tt-flip]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (e.target.closest('a')) return;
      el.classList.toggle('is-flipped');
    });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); el.classList.toggle('is-flipped'); }
    });
  });

  /* ---------- Custom cursor (desktop, fine pointer) ---------- */
  (function cursor() {
    if (!finePointer || reducedMotion) return;
    var cur = document.getElementById('tt-cursor');
    if (!cur) return;
    var x = -100, y = -100, tx = -100, ty = -100, scale = 1, tScale = 1;
    document.addEventListener('mousemove', function (e) {
      tx = e.clientX; ty = e.clientY;
      cur.classList.add('is-on');
    });
    document.addEventListener('mouseleave', function () { cur.classList.remove('is-on'); });
    document.querySelectorAll('a, button, input, select, .tt-tilt, [data-tt-flip]').forEach(function (el) {
      el.addEventListener('mouseenter', function () { tScale = 1.9; });
      el.addEventListener('mouseleave', function () { tScale = 1; });
    });
    (function loop() {
      x += (tx - x) * 0.2; y += (ty - y) * 0.2; scale += (tScale - scale) * 0.2;
      cur.style.transform = 'translate(' + (x - 13) + 'px,' + (y - 13) + 'px) scale(' + scale + ')';
      requestAnimationFrame(loop);
    })();
  })();

  /* ---------- Scroll progress ---------- */
  (function progress() {
    var bar = document.querySelector('#tt-scroll-progress span');
    if (!bar) return;
    function upd() {
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      bar.style.transform = 'scaleX(' + (max > 0 ? h.scrollTop / max : 0) + ')';
    }
    window.addEventListener('scroll', upd, { passive: true });
    upd();
  })();

  /* ---------- Back to top ---------- */
  (function backTop() {
    var btn = document.getElementById('tt-back-top');
    if (!btn) return;
    window.addEventListener('scroll', function () {
      btn.hidden = window.scrollY < 600;
    }, { passive: true });
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' }); });
  })();

  /* ---------- Homepage section nav dots ---------- */
  (function navDots() {
    if (!document.body.classList.contains('template-index')) return;
    var wrap = document.getElementById('tt-nav-dots');
    if (!wrap) return;
    var secs = Array.prototype.slice.call(document.querySelectorAll('main .tt-hero, main .tt-section, main .tt-banner'))
      .filter(function (s) { return s.offsetHeight > 120; });
    if (secs.length < 2) return;
    wrap.hidden = false;
    secs.forEach(function (sec, i) {
      var b = document.createElement('button');
      var title = sec.querySelector('h1, h2');
      b.setAttribute('aria-label', title ? title.textContent.trim() : 'Section ' + (i + 1));
      b.addEventListener('click', function () { sec.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth' }); });
      wrap.appendChild(b);
    });
    var dots = wrap.querySelectorAll('button');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var idx = secs.indexOf(e.target);
          dots.forEach(function (d, di) { d.classList.toggle('is-active', di === idx); });
        }
      });
    }, { threshold: 0.4 });
    secs.forEach(function (s) { io.observe(s); });
  })();

  /* ---------- Collection filters + sort ---------- */
  (function filters() {
    var form = document.getElementById('tt-filter-form');
    if (form) {
      form.addEventListener('change', function () { form.submit(); });
    }
    var sort = document.getElementById('tt-sort');
    if (sort) {
      sort.addEventListener('change', function () {
        document.getElementById('tt-sort-form').submit();
      });
    }
    var toggle = document.getElementById('tt-filters-toggle');
    var panel = document.getElementById('tt-filters');
    var close = document.getElementById('tt-filters-close');
    if (toggle && panel) toggle.addEventListener('click', function () { panel.classList.add('is-open'); });
    if (close && panel) close.addEventListener('click', function () { panel.classList.remove('is-open'); });
  })();

  /* ---------- Product page ---------- */
  (function productPage() {
    /* Gallery thumbs */
    document.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-thumb');
        var slides = document.querySelectorAll('.tt-gallery-slide');
        slides.forEach(function (s, idx) {
          var active = s.getAttribute('data-media-id') === id;
          s.classList.toggle('is-active', active);
          if (active) {
            var counter = document.getElementById('tt-gallery-current');
            if (counter) counter.textContent = idx + 1;
          }
        });
        document.querySelectorAll('[data-thumb]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
      });
    });

    /* Option selected display */
    document.querySelectorAll('.tt-option-pill input, .tt-color-swatch input').forEach(function (input) {
      input.addEventListener('change', function () {
        var fieldset = input.closest('.tt-option');
        var display = fieldset.querySelector('.tt-option-selected');
        if (display) display.textContent = input.value;
      });
    });

    var jsonEl = document.getElementById('tt-product-json');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var variantInput = document.getElementById('tt-variant-id');
    var priceEl = document.getElementById('tt-price');
    var addBtn = document.getElementById('tt-add-cart');

    function currentOptions() {
      var opts = [];
      product.options.forEach(function (name, i) {
        var checked = document.querySelector('input[name="option-' + i + '"]:checked');
        if (checked) opts.push(checked.value);
      });
      return opts;
    }
    function findVariant() {
      var opts = currentOptions();
      return product.variants.find(function (v) {
        return v.options.every(function (ov, i) { return ov === opts[i]; });
      });
    }
    document.querySelectorAll('.tt-option-pill input, .tt-color-swatch input').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var v = findVariant();
        if (!v) {
          variantInput.value = ''; addBtn.disabled = true;
          addBtn.textContent = (cfg.strings || {}).unavailable || 'Unavailable';
          var invalidSticky = document.getElementById('tt-sticky-add');
          if (invalidSticky) invalidSticky.disabled = true;
          return;
        }
        variantInput.value = v.id;
        priceEl.innerHTML = formatMoney(v.price) +
          (v.compare_at_price && v.compare_at_price > v.price ? ' <s>' + formatMoney(v.compare_at_price) + '</s>' : '');
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? addBtn.getAttribute('data-add-label') || 'Add to cart' : 'Sold out';
        
        // Update selected option label
        var fieldset = radio.closest('fieldset');
        if (fieldset) {
          var label = fieldset.querySelector('.tt-option-selected');
          if (label) label.textContent = radio.value;
        }
        
        // Dynamic image gallery: show variant image first, highlight it
        if (v.featured_media) {
          var mid = String(v.featured_media.id);
          var targetSlide = document.querySelector('.tt-grid-image[data-media-id="' + mid + '"]');
          if (targetSlide) {
            // Scroll to the variant image
            targetSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
            // Add highlight effect
            document.querySelectorAll('.tt-grid-image').forEach(function (img) {
              img.style.opacity = '0.5';
              img.style.transition = 'opacity 0.3s ease';
            });
            targetSlide.style.opacity = '1';
            targetSlide.style.boxShadow = '0 0 0 3px #FF6B2C';
            setTimeout(function () {
              document.querySelectorAll('.tt-grid-image').forEach(function (img) {
                img.style.opacity = '1';
                img.style.boxShadow = 'none';
              });
            }, 1200);
          }
        }
        
        // Update sticky bar price
        var stickyPrice = document.getElementById('tt-sticky-price');
        if (stickyPrice) stickyPrice.innerHTML = formatMoney(v.price);
        var stickyButton = document.getElementById('tt-sticky-add');
        if (stickyButton) { stickyButton.disabled = !v.available; stickyButton.textContent = addBtn.textContent; }
        var variantUrl = new URL(window.location.href); variantUrl.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', variantUrl);
      });
    });

    var sizeHelp = document.querySelector('[data-size-help]');
    if (sizeHelp) sizeHelp.addEventListener('click', function () {
      var summary = document.getElementById('up-size-help');
      if (summary) { summary.closest('details').open = true; summary.focus({preventScroll: true}); }
    });

    /* Quantity stepper */
    var qty = document.getElementById('tt-qty');
    var minus = document.getElementById('tt-qty-minus');
    var plus = document.getElementById('tt-qty-plus');
    if (minus && qty) minus.addEventListener('click', function () { qty.value = Math.max(1, parseInt(qty.value, 10) - 1); });
    if (plus && qty) plus.addEventListener('click', function () { qty.value = parseInt(qty.value, 10) + 1; });

    /* AJAX add to cart */
    var form = document.getElementById('tt-product-form');
    if (form) {
      if (addBtn) addBtn.setAttribute('data-add-label', addBtn.textContent.trim());
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn.disabled || !variantInput.value) return;
        var errorEl = document.getElementById('up-product-error');
        if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
        addBtn.disabled = true; addBtn.setAttribute('aria-busy', 'true');
        var label = addBtn.getAttribute('data-add-label') || 'Add to cart';
        addBtn.textContent = (cfg.strings || {}).adding || 'Adding...';
        fetch((cfg.rootUrl || '/') + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json().then(function (data) {
            if (!r.ok) throw new Error(data.description || data.message || (cfg.strings || {}).cartError || 'Please try again.');
            return data;
          }); })
          .then(function () {
            addBtn.disabled = false; addBtn.removeAttribute('aria-busy');
            addBtn.textContent = label;
            toast('Added to cart');
            refreshCartCount();
            openCartDrawer();
          })
          .catch(function (error) {
            addBtn.disabled = false; addBtn.removeAttribute('aria-busy'); addBtn.textContent = label;
            var message = error.message === 'Offline' || error instanceof TypeError ? ((cfg.strings || {}).cartError || 'Please try again.') : error.message;
            if (errorEl) { errorEl.textContent = message; errorEl.hidden = false; }
            toast(message);
          });
      });
    }
  })();

  /* ---------- Cart: count, drawer ---------- */
  function refreshCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var badge = document.getElementById('tt-cart-count');
      if (badge) {
        badge.textContent = cart.item_count;
        badge.hidden = cart.item_count === 0;
      }
      var dc = document.getElementById('tt-drawer-count');
      if (dc) dc.textContent = cart.item_count;
    });
  }

  function renderDrawer(cart) {
    var lines = document.getElementById('tt-drawer-lines');
    var subtotal = document.getElementById('tt-drawer-subtotal');
    if (!lines) return;
    if (cart.items.length === 0) {
      lines.innerHTML = '<p class="tt-drawer-empty">Your cart is empty. The pack awaits.</p>';
    } else {
      lines.innerHTML = cart.items.map(function (item) {
        return '<div class="tt-drawer-line">' +
          '<a href="' + item.url + '"><img src="' + item.image.replace(/(\.[a-z]+)$/i, '_200x$1') + '" alt="" loading="lazy"></a>' +
          '<div><h4>' + item.product_title + '</h4>' +
          (item.variant_title ? '<p class="tt-cart-variant">' + item.variant_title + '</p>' : '') +
          '<label class="tt-qty"><button type="button" data-dq="-1" data-key="' + item.key + '">-</button>' +
          '<input type="number" value="' + item.quantity + '" min="0" data-dqty="' + item.key + '" aria-label="Quantity">' +
          '<button type="button" data-dq="1" data-key="' + item.key + '">+</button></label></div>' +
          '<div><strong>' + formatMoney(item.final_line_price) + '</strong><br>' +
          '<a href="#" class="tt-cart-remove" data-remove="' + item.key + '">Remove</a></div></div>';
      }).join('');
    }
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    var checkoutButton = document.getElementById('up-drawer-checkout');
    if (checkoutButton) checkoutButton.disabled = cart.items.length === 0;
    /* Free shipping progress */
    var threshold = cfg.shipThresholdCents || 7500;
    var fill = document.getElementById('tt-ship-fill');
    var msg = document.getElementById('tt-ship-msg');
    if (fill && msg) {
      var pct = Math.min(100, Math.round(cart.total_price / threshold * 100));
      fill.style.width = pct + '%';
      if (cart.total_price >= threshold) {
        msg.textContent = 'You unlocked FREE shipping.';
      } else {
        msg.textContent = formatMoney(threshold - cart.total_price) + ' away from free shipping';
      }
    }
    bindDrawerLines();
  }

  function bindDrawerLines() {
    document.querySelectorAll('[data-dq]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-key');
        var input = document.querySelector('[data-dqty="' + key + '"]');
        var qty = Math.max(0, parseInt(input.value, 10) + parseInt(btn.getAttribute('data-dq'), 10));
        updateLine(key, qty);
      });
    });
    document.querySelectorAll('[data-dqty]').forEach(function (input) {
      input.addEventListener('change', function () {
        updateLine(input.getAttribute('data-dqty'), Math.max(0, parseInt(input.value, 10) || 0));
      });
    });
    document.querySelectorAll('[data-remove]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        updateLine(link.getAttribute('data-remove'), 0);
      });
    });
  }

  function updateLine(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderDrawer(cart); refreshCartCount(); });
  }

  function loadUpsells() {
    var handle = cfg.upsellCollection;
    var row = document.getElementById('tt-upsell-row');
    var box = document.getElementById('tt-drawer-upsell');
    if (!handle || !row || !box || row.getAttribute('data-loaded')) return;
    fetch('/collections/' + handle + '/products.json?limit=4')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var items = (d.products || []).slice(0, 4);
        if (!items.length) return;
        row.setAttribute('data-loaded', '1');
        row.innerHTML = items.map(function (p) {
          return '<a class="tt-upsell-item" href="/products/' + p.handle + '">' +
            '<img src="' + (p.images && p.images[0] ? p.images[0].src.replace(/(\.[a-z]+)(\?.*)?$/i, '_200x$1') : '') + '" alt="" loading="lazy">' +
            '<span>' + p.title.substring(0, 24) + '</span><strong>' + formatMoney(Math.round(parseFloat(p.variants[0].price) * 100)) + '</strong></a>';
        }).join('');
        box.hidden = false;
      })
      .catch(function () {});
  }

  function openCartDrawer() {
    var drawer = document.getElementById('tt-cart-drawer');
    var overlay = document.getElementById('tt-drawer-overlay');
    if (!drawer || !overlay) { window.location.href = cfg.cartUrl || '/cart'; return; }
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      renderDrawer(cart);
      loadUpsells();
      drawer.hidden = false;
      overlay.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
    });
  }
  function closeCartDrawer() {
    var drawer = document.getElementById('tt-cart-drawer');
    var overlay = document.getElementById('tt-drawer-overlay');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    setTimeout(function () { drawer.hidden = true; overlay.hidden = true; }, 380);
    document.body.style.overflow = '';
  }
  (function drawerEvents() {
    var openBtn = document.getElementById('tt-cart-open');
    if (openBtn) openBtn.addEventListener('click', function (e) { e.preventDefault(); openCartDrawer(); });
    var closeBtn = document.getElementById('tt-drawer-close');
    if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
    var overlay = document.getElementById('tt-drawer-overlay');
    if (overlay) overlay.addEventListener('click', closeCartDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCartDrawer(); });
  })();

  /* ---------- Quick view ---------- */
  (function quickView() {
    var overlay = document.getElementById('tt-qv-overlay');
    if (!overlay) return;
    var qvVariantId = null;
    function openQV(handle) {
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          document.getElementById('tt-qv-title').textContent = p.title;
          var media = document.getElementById('tt-qv-media');
          media.innerHTML = p.images.slice(0, 1).map(function (src) {
            return '<img src="' + src.replace(/(\.[a-z]+)(\?.*)?$/i, '_800x$1') + '" alt="">';
          }).join('');
          var optsBox = document.getElementById('tt-qv-options');
          optsBox.innerHTML = '';
          qvVariantId = p.variants[0].id;
          function paintPrice(v) {
            document.getElementById('tt-qv-price').textContent = formatMoney(v.price);
          }
          paintPrice(p.variants[0]);
          if (p.variants.length > 1 && p.options.length) {
            /* p.options items may be strings or {name, position, values} objects */
            var optNames = p.options.map(function (o) { return (o && o.name) ? o.name : o; });
            optNames.forEach(function (name, oi) {
              var fs = document.createElement('fieldset');
              fs.className = 'tt-option';
              var lg = document.createElement('legend');
              lg.textContent = name;
              fs.appendChild(lg);
              var vals = document.createElement('div');
              vals.className = 'tt-option-values';
              var seen = {};
              p.variants.forEach(function (v) {
                var val = v['option' + (oi + 1)];
                if (seen[val]) return;
                seen[val] = true;
                var lab = document.createElement('label');
                lab.className = 'tt-option-pill';
                lab.innerHTML = '<input type="radio" name="qv-opt-' + oi + '" value="' + val.replace(/"/g, '&quot;') + '"><span>' + val + '</span>';
                vals.appendChild(lab);
              });
              fs.appendChild(vals);
              optsBox.appendChild(fs);
            });
            optsBox.querySelectorAll('input[type="radio"]').forEach(function (radio) {
              radio.addEventListener('change', syncQV);
            });
            /* check first option of each group, then sync */
            optNames.forEach(function (n, oi) {
              var first = optsBox.querySelector('input[name="qv-opt-' + oi + '"]');
              if (first) first.checked = true;
            });
            syncQV();
          }
          function syncQV() {
            var chosen = optNames.map(function (n, oi) {
              var c = optsBox.querySelector('input[name="qv-opt-' + oi + '"]:checked');
              return c ? c.value : null;
            });
            var v = p.variants.find(function (vv) {
              return chosen.every(function (c, oi) { return vv['option' + (oi + 1)] === c; });
            }) || p.variants[0];
            qvVariantId = v.id;
            paintPrice(v);
          }
          document.getElementById('tt-qv-full').href = '/products/' + p.handle;
          document.getElementById('tt-qv-qty').value = 1;
          overlay.hidden = false;
          document.body.style.overflow = 'hidden';
        });
    }
    function closeQV() {
      overlay.hidden = true;
      document.body.style.overflow = '';
    }
    document.querySelectorAll('[data-qv]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openQV(btn.getAttribute('data-qv')); });
    });
    document.getElementById('tt-qv-close').addEventListener('click', closeQV);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeQV(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) closeQV(); });
    var qvMinus = document.getElementById('tt-qv-minus');
    var qvPlus = document.getElementById('tt-qv-plus');
    var qvQty = document.getElementById('tt-qv-qty');
    if (qvMinus) qvMinus.addEventListener('click', function () { qvQty.value = Math.max(1, parseInt(qvQty.value, 10) - 1); });
    if (qvPlus) qvPlus.addEventListener('click', function () { qvQty.value = parseInt(qvQty.value, 10) + 1; });
    document.getElementById('tt-qv-add').addEventListener('click', function () {
      if (!qvVariantId) return;
      var btn = this;
      btn.disabled = true;
      fetch((cfg.rootUrl || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: qvVariantId, quantity: parseInt(qvQty.value, 10) || 1 })
      })
        .then(function (r) { return r.json().then(function (data) { if (!r.ok) throw new Error(data.description || data.message || (cfg.strings || {}).cartError || 'Please try again.'); return data; }); })
        .then(function () {
          btn.disabled = false;
          closeQV();
          toast('Added to cart');
          refreshCartCount();
          openCartDrawer();
        })
        .catch(function (error) { btn.disabled = false; toast(error.message); });
    });
  })();

  /* ---------- Predictive search ---------- */
  (function search() {
    var openBtn = document.getElementById('tt-search-open');
    var overlay = document.getElementById('tt-search-overlay');
    if (!openBtn || !overlay) return;
    var input = document.getElementById('tt-search-input');
    var results = document.getElementById('tt-search-results');
    var timer = null;
    openBtn.addEventListener('click', function (e) {
      e.preventDefault();
      overlay.hidden = false;
      document.body.style.overflow = 'hidden';
      setTimeout(function () { input.focus(); }, 60);
    });
    function closeSearch() { overlay.hidden = true; document.body.style.overflow = ''; }
    document.getElementById('tt-search-close').addEventListener('click', closeSearch);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) closeSearch(); });
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch(cfg.searchSuggestUrl + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var items = (d.resources && d.resources.results && d.resources.results.products) || [];
            if (!items.length) { results.innerHTML = '<p class="tt-empty" style="color:var(--color-cream)">No matches. Try a breed name.</p>'; return; }
            results.innerHTML = items.map(function (p) {
              return '<a class="tt-search-hit" href="' + p.url + '">' +
                (p.featured_image ? '<img src="' + p.featured_image.url.replace(/(\.[a-z]+)(\?.*)?$/i, '_200x$1') + '" alt="" loading="lazy">' : '') +
                '<span>' + p.title + '</span><strong>' + formatMoney(p.price) + '</strong></a>';
            }).join('');
          })
          .catch(function () {});
      }, 260);
    });
  })();

  /* ---------- Breed finder quiz ---------- */
  (function quiz() {
    document.querySelectorAll('[data-tt-quiz]').forEach(function (root) {
      var panels = {
        start: root.querySelector('[data-quiz-panel="start"]'),
        questions: root.querySelector('[data-quiz-panel="questions"]'),
        result: root.querySelector('[data-quiz-panel="result"]')
      };
      var cards = Array.prototype.slice.call(root.querySelectorAll('.tt-quiz-card'));
      var bar = root.querySelector('[data-quiz-progress-bar]');
      var stepEl = root.querySelector('[data-quiz-step]');
      var scores = {};
      var idx = 0;
      var KEY = 'tt-quiz-style';

      function showPanel(name) {
        Object.keys(panels).forEach(function (k) { if (panels[k]) panels[k].hidden = k !== name; });
      }
      function showCard(i) {
        cards.forEach(function (c, ci) { c.hidden = ci !== i; });
        idx = i;
        if (bar) bar.style.width = (i / cards.length * 100) + '%';
        if (stepEl) stepEl.textContent = 'QUESTION ' + (i + 1) + ' OF ' + cards.length;
      }
      function finish() {
        var top = Object.keys(scores).sort(function (a, b) { return scores[b] - scores[a]; })[0] || 'bootleg';
        try { localStorage.setItem(KEY, top); } catch (e) {}
        if (bar) bar.style.width = '100%';
        root.querySelectorAll('.tt-quiz-result-card').forEach(function (rc) {
          rc.hidden = rc.getAttribute('data-result') !== top;
        });
        showPanel('result');
        paintResume();
      }
      function paintResume() {
        var saved = null;
        try { saved = localStorage.getItem(KEY); } catch (e) {}
        var resume = root.querySelector('[data-quiz-resume]');
        if (resume && saved) {
          resume.hidden = false;
          resume.innerHTML = 'Last time you got <strong>' + saved.toUpperCase() + '</strong>. <button type="button" class="tt-link-arrow" data-quiz-skip>See my picks</button>';
          var skip = resume.querySelector('[data-quiz-skip]');
          if (skip) skip.addEventListener('click', function () {
            scores = {}; scores[saved] = 99;
            finish();
          });
        }
      }
      var startBtn = root.querySelector('[data-quiz-start]');
      if (startBtn) startBtn.addEventListener('click', function () {
        scores = {}; showPanel('questions'); showCard(0);
      });
      root.querySelectorAll('.tt-quiz-option').forEach(function (opt) {
        opt.addEventListener('click', function () {
          var st = opt.getAttribute('data-style');
          scores[st] = (scores[st] || 0) + 1;
          if (idx + 1 < cards.length) { showCard(idx + 1); }
          else { finish(); }
        });
      });
      var restart = root.querySelector('[data-quiz-restart]');
      if (restart) restart.addEventListener('click', function () { scores = {}; showPanel('start'); });
      paintResume();
    });
  })();

  /* ---------- Spin wheel ---------- */
  (function wheel() {
    var overlay = document.getElementById('tt-wheel-overlay');
    if (!overlay) return;
    if (reducedMotion) return;
    try {
      if (sessionStorage.getItem('tt-wheel-seen')) return;
    } catch (e) {}
    var delay = parseInt(overlay.getAttribute('data-delay'), 10) || 12;
    var wheelEl = document.getElementById('tt-wheel');
    var spinBtn = document.getElementById('tt-wheel-spin');
    var segs = Array.prototype.slice.call(wheelEl.querySelectorAll('.tt-wheel-seg'));
    if (!segs.length) return;
    var n = segs.length;
    var shown = false;
    function show() {
      if (shown) return;
      shown = true;
      overlay.hidden = false;
      try { sessionStorage.setItem('tt-wheel-seen', '1'); } catch (e) {}
    }
    setTimeout(show, delay * 1000);
    document.getElementById('tt-wheel-close').addEventListener('click', function () { overlay.hidden = true; });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) overlay.hidden = true; });
    spinBtn.addEventListener('click', function () {
      spinBtn.disabled = true;
      var win = Math.floor(Math.random() * n);
      var segDeg = 360 / n;
      /* pointer at top; rotate so winning segment center lands under it */
      var target = 360 * 6 - (win * segDeg + segDeg / 2);
      wheelEl.style.transform = 'rotate(' + target + 'deg)';
      setTimeout(function () {
        document.getElementById('tt-wheel-code').textContent = segs[win].getAttribute('data-code') || segs[win].textContent;
        overlay.querySelector('[data-wheel-stage="spin"]').hidden = true;
        overlay.querySelector('[data-wheel-stage="win"]').hidden = false;
      }, 4400);
    });
  })();

  /* ---------- Compare slider ---------- */
  (function compare() {
    document.querySelectorAll('[data-tt-compare]').forEach(function (slider) {
      var range = slider.querySelector('[data-compare-range]');
      if (!range) return;
      function setPos(v) { slider.style.setProperty('--pos', v + '%'); }
      range.addEventListener('input', function () { setPos(range.value); });
      setPos(range.value);
    });
  })();

  refreshCartCount();
})();

/* ============================================================
   RESEARCH-DRIVEN UPGRADES (2026-10-12)
   ============================================================ */
(function () {
  'use strict';
  var cfg = window.TT || {};
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function formatMoney(cents) {
    if (cfg.currency) {
      return new Intl.NumberFormat(cfg.locale || 'en', {style: 'currency', currency: cfg.currency}).format(cents / 100);
    }
    var fmt = cfg.moneyFormat || '${{amount}}';
    return fmt.replace('{{amount_with_comma_separator}}', (cents / 100).toFixed(2).replace('.', ',')).replace('{{amount}}', (cents / 100).toFixed(2));
  }

  /* ---------- Sticky mobile ATC: show past buy box ---------- */
  (function stickyATC() {
    var bar = document.getElementById('tt-sticky-atc');
    var buyBox = document.getElementById('tt-buy-box');
    var stickyAdd = document.getElementById('tt-sticky-add');
    if (!bar || !buyBox) return;
    bar.hidden = false;
    var io = new IntersectionObserver(function (entries) {
      var buyVisible = entries[0].isIntersecting;
      var pastBuy = window.scrollY > buyBox.getBoundingClientRect().bottom + window.scrollY;
      bar.classList.toggle('is-visible', !buyVisible && pastBuy);
    }, { threshold: 0 });
    io.observe(buyBox);
    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        var main = document.getElementById('tt-add-cart');
        if (main) main.click();
        else {
          var form = document.getElementById('tt-product-form');
          if (form) form.requestSubmit();
        }
      });
    }
  })();

  /* ---------- Wishlist (localStorage) ---------- */
  (function wishlist() {
    var KEY = 'tt-wishlist';
    function get() {
      try { return JSON.parse(localStorage.getItem(KEY)) || []; }
      catch (e) { return []; }
    }
    function set(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }
    function paint() {
      var list = get();
      document.querySelectorAll('[data-wishlist]').forEach(function (btn) {
        var active = list.indexOf(btn.getAttribute('data-wishlist')) !== -1;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }
    document.querySelectorAll('[data-wishlist]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var handle = btn.getAttribute('data-wishlist');
        var list = get();
        var i = list.indexOf(handle);
        if (i === -1) list.push(handle); else list.splice(i, 1);
        set(list);
        paint();
      });
    });
    paint();
  })();

  /* ---------- Quick add (single-variant products) ---------- */
  (function quickAdd() {
    document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var id = btn.getAttribute('data-quick-add');
        btn.disabled = true;
        var label = btn.textContent;
        btn.textContent = 'Adding...';
        fetch((cfg.rootUrl || '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: id, quantity: 1 })
        })
          .then(function (r) { return r.json().then(function (data) { if (!r.ok) throw new Error(data.description || data.message || (cfg.strings || {}).cartError || 'Please try again.'); return data; }); })
          .then(function () {
            btn.disabled = false;
            btn.textContent = label;
            var toast = document.getElementById('tt-cart-toast');
            if (toast) {
              toast.textContent = 'Added to cart';
              toast.classList.add('is-show');
              setTimeout(function () { toast.classList.remove('is-show'); }, 2600);
            }
            var cartOpen = document.getElementById('tt-cart-open');
            if (cartOpen) cartOpen.click();
          })
          .catch(function (error) {
            btn.disabled = false; btn.textContent = label;
            var notice = document.getElementById('tt-cart-toast');
            if (notice) { notice.textContent = error.message; notice.classList.add('is-show'); setTimeout(function () { notice.classList.remove('is-show'); }, 5000); }
          });
      });
    });
  })();

  /* ---------- Recently viewed: track + render ---------- */
  (function recentlyViewed() {
    var KEY = 'tt-recently-viewed';
    var MAX = 8;
    function get() {
      try { return JSON.parse(localStorage.getItem(KEY)) || []; }
      catch (e) { return []; }
    }
    function set(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }
    /* Track: on product pages, record handle */
    var jsonEl = document.getElementById('tt-product-json');
    if (jsonEl) {
      try {
        var p = JSON.parse(jsonEl.textContent);
        var list = get().filter(function (h) { return h !== p.handle; });
        list.unshift(p.handle);
        set(list.slice(0, MAX));
      } catch (e) {}
    }
    /* Render: fill the section grid */
    var section = document.getElementById('tt-recently-viewed');
    var grid = document.getElementById('tt-recently-grid');
    if (!section || !grid) return;
    var current = jsonEl ? null : null;
    var handles = get();
    if (jsonEl) {
      try { var cp = JSON.parse(jsonEl.textContent); handles = handles.filter(function (h) { return h !== cp.handle; }); }
      catch (e) {}
    }
    handles = handles.slice(0, 4);
    if (!handles.length) return;
    var loaded = 0;
    handles.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (prod) {
          var img = prod.images && prod.images[0] ? prod.images[0].replace(/(\.[a-z]+)(\?.*)?$/i, '_400x$1') : '';
          var card = document.createElement('article');
          card.className = 'tt-product-card';
          card.innerHTML =
            '<a href="/products/' + prod.handle + '" class="tt-card-link"><span class="tt-visually-hidden">' + prod.title.replace(/</g, '&lt;') + '</span></a>' +
            '<div class="tt-card-media">' +
            (img ? '<img src="' + img + '" alt="" loading="lazy" class="tt-card-img tt-card-img-main">' : '') +
            '</div>' +
            '<div class="tt-card-body"><h3 class="tt-card-title" aria-hidden="true">' + prod.title.replace(/</g, '&lt;') + '</h3>' +
            '<p class="tt-card-price">' + formatMoney(prod.price) + '</p></div>';
          grid.appendChild(card);
          loaded++;
          if (loaded > 0) section.hidden = false;
        })
        .catch(function () {});
    });
  })();
})();

  /* ---------- Breed Rush game ---------- */
  document.querySelectorAll('[data-tt-rush]').forEach(function (game) {
    var BREEDS = ['Golden Retriever', 'French Bulldog', 'Labrador', 'Beagle', 'Husky', 'Pug', 'Dachshund', 'Corgi', 'Beagle', 'Poodle', 'Rottweiler', 'Boxer'];
    var arena = game.querySelector('[data-rush-arena]');
    var startEl = game.querySelector('[data-rush-start]');
    var endEl = game.querySelector('[data-rush-end]');
    var targetEl = game.querySelector('[data-rush-target]');
    var scoreEl = game.querySelector('[data-rush-score]');
    var timeEl = game.querySelector('[data-rush-time]');
    var totalTime = parseInt(game.getAttribute('data-time'), 10) || 30;
    var winScore = parseInt(game.getAttribute('data-win-score'), 10) || 15;
    var winCode = game.getAttribute('data-win-code') || 'PACK10';
    var section = game.closest('section');
    var score = 0, timeLeft = totalTime, target = '', timer = null, spawnTimer = null, playing = false;

    function pickTarget() {
      target = BREEDS[Math.floor(Math.random() * BREEDS.length)];
      targetEl.textContent = target;
    }
    function spawnBreed() {
      if (!playing) return;
      var breed = BREEDS[Math.floor(Math.random() * BREEDS.length)];
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'tt-rush-breed';
      btn.textContent = breed;
      var maxX = Math.max(arena.clientWidth - 140, 20);
      var maxY = Math.max(arena.clientHeight - 60, 20);
      btn.style.left = (10 + Math.random() * maxX) + 'px';
      btn.style.top = (10 + Math.random() * maxY) + 'px';
      btn.addEventListener('click', function () {
        if (!playing) return;
        if (breed === target) {
          score++;
          scoreEl.textContent = score;
          btn.classList.add('hit');
          pickTarget();
        } else {
          btn.classList.add('miss');
        }
        setTimeout(function () { btn.remove(); }, 220);
      });
      arena.appendChild(btn);
      requestAnimationFrame(function () { btn.classList.add('pop'); });
      setTimeout(function () { if (btn.parentNode) btn.remove(); }, 1600);
      spawnTimer = setTimeout(spawnBreed, 500 + Math.random() * 500);
    }
    function endGame() {
      playing = false;
      clearInterval(timer);
      clearTimeout(spawnTimer);
      arena.querySelectorAll('.tt-rush-breed').forEach(function (b) { b.remove(); });
      endEl.hidden = false;
      var title = endEl.querySelector('[data-rush-endtitle]');
      var text = endEl.querySelector('[data-rush-endtext]');
      var reward = endEl.querySelector('[data-rush-reward]');
      if (score >= winScore) {
        title.textContent = 'Pack leader!';
        text.textContent = 'You scored ' + score + '. Here is your reward.';
        reward.innerHTML = '<span class="tt-rush-reward-code">' + winCode + '</span><p style="margin-top:8px;font-size:0.9rem;opacity:0.8">Use at checkout for 10% off.</p>';
      } else {
        title.textContent = 'Good try!';
        text.textContent = 'You scored ' + score + '. You need ' + winScore + ' to unlock the discount. Go again?';
        reward.innerHTML = '';
      }
    }
    function startGame() {
      score = 0; timeLeft = totalTime; playing = true;
      scoreEl.textContent = '0';
      timeEl.textContent = timeLeft;
      startEl.style.display = 'none';
      endEl.hidden = true;
      pickTarget();
      spawnBreed();
      timer = setInterval(function () {
        timeLeft--;
        timeEl.textContent = timeLeft;
        if (timeLeft <= 0) endGame();
      }, 1000);
    }
    var playBtn = game.querySelector('[data-rush-play]');
    if (playBtn) playBtn.addEventListener('click', startGame);
    var againBtn = game.querySelector('[data-rush-again]');
    if (againBtn) againBtn.addEventListener('click', startGame);
  });

  /* ---------- Pack roll: drag to scroll ---------- */
  document.querySelectorAll('[data-tt-packroll]').forEach(function (wrap) {
    var strip = wrap.querySelector('[data-packroll-strip]');
    if (!strip) return;
    var isDown = false, startX = 0, startScroll = 0;
    strip.addEventListener('pointerdown', function (e) {
      isDown = true;
      startX = e.clientX;
      startScroll = strip.scrollLeft;
      strip.classList.add('dragging');
      strip.setPointerCapture(e.pointerId);
    });
    strip.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      strip.scrollLeft = startScroll - (e.clientX - startX);
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
      strip.addEventListener(ev, function () {
        isDown = false;
        strip.classList.remove('dragging');
      });
    });
  });

  /* ---------- Hero carousel ---------- */
  document.querySelectorAll('[data-tt-carousel]').forEach(function (car) {
    var slides = car.querySelectorAll('[data-slide]');
    var dots = car.querySelectorAll('[data-dot]');
    if (slides.length < 2) return;
    var current = 0;
    var autoplay = car.getAttribute('data-autoplay') === 'true';
    var interval = (parseInt(car.getAttribute('data-interval'), 10) || 6) * 1000;
    var timer = null;
    function goTo(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === current); });
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === current); });
    }
    function start() {
      if (!autoplay) return;
      stop();
      timer = setInterval(function () { goTo(current + 1); }, interval);
    }
    function stop() { if (timer) clearInterval(timer); }
    dots.forEach(function (d) {
      d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-dot'), 10)); start(); });
    });
    var prev = car.querySelector('[data-carousel-prev]');
    var next = car.querySelector('[data-carousel-next]');
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); start(); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); start(); });
    car.addEventListener('mouseenter', stop);
    car.addEventListener('mouseleave', start);
    /* touch swipe */
    var startX = 0;
    car.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; stop(); }, { passive: true });
    car.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) goTo(current + (dx < 0 ? 1 : -1));
      start();
    }, { passive: true });
    start();
  });

// Image zoom lightbox
document.addEventListener('DOMContentLoaded', function() {
  const lightbox = document.getElementById('tt-lightbox');
  const lightboxImg = document.getElementById('tt-lightbox-img');
  if (!lightbox) return;
  
  document.querySelectorAll('.tt-grid-image[data-zoom-src]').forEach(function(el) {
    el.addEventListener('click', function() {
      lightboxImg.src = el.dataset.zoomSrc;
      lightboxImg.alt = el.querySelector('img') ? el.querySelector('img').alt : '';
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });
  });
  
  function closeLightbox() {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  
  lightbox.querySelector('.tt-lightbox-close').addEventListener('click', closeLightbox);
  lightbox.addEventListener('click', function(e) {
    if (e.target === lightbox) closeLightbox();
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && lightbox.classList.contains('is-open')) closeLightbox();
  });
});

